<template>
  <div>
    <div
      v-if="share.isDeeplinkGenerating.value"
      class="flex size-6 items-center justify-center"
    >
      <FreeLoader without-base size="xs" />
    </div>
    <template v-else>
      <button
        v-if="share.isShareAvailable.value"
        type="button"
        class="flex items-center"
        @click="onClick"
      >
        <ShareIcon class="text-text-neutral-primary" />
      </button>
    </template>
  </div>
</template>

<script setup lang="ts">
  import { FreeLoader } from 'freedom-shared';

  import ShareIcon from '@/assets/images/share-icon.svg?component';

  import { useShare } from './model';

  const props = defineProps<{
    title: string;
    pathForDeeplink?: string;
    source?: string;
  }>();

  const share = useShare();

  const onClick = () => {
    share.requestShare({
      title: props.title,
      source: props.source,
      ...(props.pathForDeeplink ? { url: props.pathForDeeplink } : {}),
    });
  };
</script>
